module.exports = __webpack_public_path__ + "img/16l009-09.6465ee1a.jpg";